import React from "react";
import {
  NewBox as Box,
  NewButton as Button,
  NewTypography as Typography,
} from "@bca/ui-library";
import styled from "styled-components";
import { useViewport } from "@bca/ui-library";

import NoResultsIcon from "../../icons/NoResultsIcon";

const CustomBox = styled(Box)`
  margin-top: 8vh;
`;

const NoResultsGeneral: React.FC = () => {
  const viewport = useViewport();

  const openStockAlertsPage = () => {
    window.location.href = "/search/StockAlerts";
  };

  return (
    <CustomBox
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      paddingBottom="xxl"
    >
      <NoResultsIcon></NoResultsIcon>
      <Typography variant="h5" marginTop="lg" marginBottom="xs">
        No saved search & Stock Alert yet
      </Typography>
      <Typography variant="body-large" textAlign="center" marginBottom="xl">
        A quick way to search your favourite vehicle ranges
      </Typography>
      <Button
        text="Create New"
        icon={viewport.greaterThan.sm ? "plus" : null}
        iconPosition="left"
        onClick={openStockAlertsPage}
      />
    </CustomBox>
  );
};

export default NoResultsGeneral;
